module.exports = __webpack_public_path__ + "static/media/bglobe-logo-white.3b15d9fd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/svg/bglobe-logo-white.svg
// module id = 64
// module chunks = 6